import type { LocaleDict } from '../../lib/i18n/types';
import type { Tone } from '../../components/ui/tone';

/** Risk level → Badge tone (high danger, medium warning, low muted). */
export const RISK_TONE: Record<'low' | 'medium' | 'high', Tone> = { low: 'muted', medium: 'warning', high: 'danger' };

/** Localized risk label shared by plugin permissions and configuration fields. */
export function riskLabel(t: LocaleDict, risk: 'low' | 'medium' | 'high'): string {
  return risk === 'high' ? t.pluginDetail.riskHigh : risk === 'medium' ? t.pluginDetail.riskMedium : t.pluginDetail.riskLow;
}

// A read-only pill for a contribution / hook name.
export const namePill = 'rounded-full border border-border px-2.5 py-1 font-mono text-small text-muted-foreground';
